export default __webpack_public_path__ + "static/media/gallery_07.33e5b049.jpg";